import { EntityBase } from "./common";
import { SourceUrlModel } from "./company";
import {
  AnnouncementType,
  AnnouncementContainedObjectsEnum,
  AnnouncementErrorTypeEnum,
  AnnouncementCategoryEnum,
  AnnouncementLetterTypeEnum,
} from "./enums";

export interface AnnouncementModel extends EntityBase {
  type: AnnouncementType;
  title: string;
  code: string;
  symbol: string;
  createDate: string;
  updateDate: string;
  publishDate: string;
  tracingNumber: string;
  url: string;
  contained: AnnouncementContainedObjectsEnum;
  errors: AnnouncementErrorModel[];
  sourceUrls: SourceUrlModel[];
}

export interface AnnouncementErrorModel extends EntityBase {
  relatedObject: AnnouncementContainedObjectsEnum;
  errorType: AnnouncementErrorTypeEnum;
}

export interface AnnouncementCollectModel {
  symbols: string[];
  category: AnnouncementCategoryEnum;
  letterType: AnnouncementLetterTypeEnum;
  mpType: CollectorMpTypeEnum;
  fsType: CollectorFsTypeEnum;
  investmentType: CollectorInvestmentTypeEnum;
  fromDate: string;
  toDate: string;
  forceUpdate: boolean;
}

export enum CollectorMpTypeEnum {
  All,
  Normal,
  Cumulative,
  RawMaterialNormal,
  RawMaterialCumulative,
  FcFlowNormal,
  FcFlowCumulative,
  EnergyNormal,
  EnergyCumulative,
}

export enum CollectorInvestmentTypeEnum {
  All = 0,
  None = 1,
  Monthly = 2,
  Periodic = 3,
}

export enum CollectorFsTypeEnum {
  All,
  ProfitAndLoss,
  BalanceSheet,
  CashFlow,
  ConsolidatedProfitAndLoss,
  ConsolidatedBalanceSheet,
  ConsolidatedCashFlow,
  OperatingIncomeAndExpense,
  Cost,
  OaCost,
  InventoryTurnover,
  InventoryTurnoverEstimated,
  PcRawMaterial,
  PcRawMaterialEstimated,
}
